export default __webpack_public_path__ + "static/media/laval8.753f570d.jpg";